export const HINT_TEXT = 'Matches occurring in either the variable descriptions or the possible values are bolded. If nothing is bolded, the match was generated using a “matching” function in Health Data Select.'
